import React from 'react';
import PropTypes from 'prop-types';
import ResultsView from '../ResultsView';
import AssetTile from '../assetTile/AssetTile';

const EquipTypeView = ({ equipmentTypes, buildingIsFetchingData, handleSelection }) => {
  const equipTypeResults = equipmentTypes.map((equipType) => (
    <AssetTile
      key={equipType.nameAbbr}
      frontTitle={equipType.nameAbbr}
      frontSubtitle={equipType.nameLong}
      frontLeftInfo={`Units: ${equipType.instances.length}`}
      frontRightInfo={`Points: ${equipType.instances.reduce(
        (runningTotal, i) => runningTotal + i.points.length,
        0
      )}`}
      frontDrilldownFunc={(e) => handleSelection(e, equipType)}
      frontDrilldownEnabled
    />
  ));
  return <ResultsView loading={buildingIsFetchingData} results={equipTypeResults} />;
};

EquipTypeView.propTypes = {
  buildingIsFetchingData: PropTypes.bool.isRequired,
  handleSelection: PropTypes.func.isRequired,
  equipmentTypes: PropTypes.arrayOf(Object).isRequired,
};

export default EquipTypeView;
